export const getIntegrationsLib = (integrationsFileName) => {
  if (!integrationsFileName) return undefined;

  // We want this to be dynamic so new integration files get picked up automagically.
  // eslint-disable-next-line global-require, import/no-dynamic-require -- directive added automatically by Shepherd migration
  const integrations = require(`./${integrationsFileName}`);

  return {
    get(integrationName) {
      return integrations[integrationName];
    },
  };
};
